module.exports = __webpack_public_path__ + "static/media/info.d8ee028c.png";